import Component from './InstagramInstantwinAnalyticsPublicFilter.vue'
export default Component
